import { render, staticRenderFns } from "./shopAccountDetailManage.vue?vue&type=template&id=c26505e4&scoped=true"
import script from "./shopAccountDetailManage.vue?vue&type=script&lang=js"
export * from "./shopAccountDetailManage.vue?vue&type=script&lang=js"
import style0 from "./shopAccountDetailManage.vue?vue&type=style&index=0&id=c26505e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26505e4",
  null
  
)

export default component.exports